import { render, staticRenderFns } from "./QueryTextarea.vue?vue&type=template&id=4d87b61e&scoped=true"
import script from "./QueryTextarea.vue?vue&type=script&lang=js"
export * from "./QueryTextarea.vue?vue&type=script&lang=js"
import style0 from "./QueryTextarea.vue?vue&type=style&index=0&id=4d87b61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87b61e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
